import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  onError,
  onLoad,
  ...props
}) {

  const handleError = (e) => {
    console.warn('[AppImage] Image failed to load:', src);
    e.target.src = "/assets/images/Logo/webp/VAS-LOGO.webp";
    // Call custom onError handler if provided
    if (onError && typeof onError === 'function') {
      onError(e);
    }
  };

  const handleLoad = (e) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[AppImage] Image loaded successfully:', src);
    }
    // Call custom onLoad handler if provided
    if (onLoad && typeof onLoad === 'function') {
      onLoad(e);
    }
  };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      {...props}
    />
  );
}

export default Image;
